import { createContext, useContext } from "react";
//#region src/components/field-context.tsx
const FieldContext = createContext(null);
const useFieldContext = () => {
	return useContext(FieldContext);
};
//#endregion
export { FieldContext, useFieldContext };

//# sourceMappingURL=field-context.js.map